import { CONTACT } from "../../data/content";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="relative bg-background border-t border-border"
    >
      <div className="mx-auto max-w-[1600px] px-6 md:px-10 py-16">
        <div className="grid md:grid-cols-12 gap-10 mb-16">
          <div className="md:col-span-6">
            <h3 className="font-display uppercase leading-[0.85] tracking-tighter text-5xl md:text-7xl">
              Atagasthya
              <br />
              <span className="text-primary">Packaging</span>
            </h3>
            <p className="font-mono-ibm text-xs tracking-widest text-muted-foreground mt-6 max-w-sm leading-relaxed">
              EXPORT-GRADE INDUSTRIAL PACKAGING · CARDBOARD · PLYWOOD · PINEWOOD
              · EPE / PU / XLPE FOAM
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-ibm text-[10px] tracking-widest uppercase text-primary mb-4">
              Contact
            </p>
            <a
              href={`tel:${CONTACT.phoneRaw}`}
              className="block font-mono-ibm text-sm text-muted-foreground hover:text-foreground transition-colors mb-2"
            >
              {CONTACT.phone}
            </a>
            <a
              href={`mailto:${CONTACT.email}`}
              className="block font-mono-ibm text-sm text-muted-foreground hover:text-foreground transition-colors"
            >
              {CONTACT.email}
            </a>
          </div>
          <div className="md:col-span-3">
            <p className="font-mono-ibm text-[10px] tracking-widest uppercase text-primary mb-4">
              Location
            </p>
            <div className="font-mono-ibm text-sm text-muted-foreground leading-relaxed">
              {CONTACT.addressLines.map((l) => (
                <p key={l}>{l}</p>
              ))}
            </div>
          </div>
        </div>

        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-t border-border pt-8">
          <p className="font-mono-ibm text-[10px] tracking-widest uppercase text-muted-foreground">
            © {new Date().getFullYear()} {CONTACT.company}. All rights reserved.
          </p>
          <p className="font-mono-ibm text-[10px] tracking-widest uppercase text-muted-foreground">
            Bengaluru · Karnataka · India
          </p>
        </div>
      </div>
    </footer>
  );
};
